import { useCurrencySymbol } from '@/hooks/useCurrencySymbol';
import { Form, InputNumber, Slider } from 'antd';
import type { FC } from 'react';

export type PriceRange = {
  min?: number;
  max?: number;
};

export const PriceRangeFilter: FC<{
  value?: PriceRange;
  onChange?: (value: PriceRange) => void;
}> = ({ value, onChange }) => {
  const { symbol, priceRange } = useCurrencySymbol();

  return (
    <div className="space-y-2">
      <div className="mx-1">
        <Slider
          range
          min={priceRange.min}
          max={priceRange.max}
          value={
            value?.min != null && value?.max != null
              ? [value.min, value.max]
              : undefined
          }
          onChange={(newValue) => {
            onChange?.({
              min: newValue[0],
              max: newValue[1],
            });
          }}
          marks={{
            [priceRange.min]: `${symbol}${priceRange.min}`,
            [priceRange.max]: `${symbol}${priceRange.max}+`,
          }}
          tooltip={{
            formatter: (value) => {
              if (value == null) return `${symbol}0`;
              return value > priceRange.max
                ? `${symbol}${priceRange.max}+`
                : `${symbol}${value}`;
            },
          }}
        />
      </div>
      <div className="flex flex-col gap-2 mt-2">
        <span className="text-sm text-gray-500">Custom price range:</span>
        <div className="flex items-center gap-2">
          <Form.Item name={['priceRange', 'min']} noStyle>
            <InputNumber
              size="small"
              min={priceRange.min}
              max={value?.max}
              placeholder="Min"
              prefix={symbol}
              className="w-24"
              value={value?.min}
              onChange={(newValue) => {
                onChange?.({
                  ...value,
                  min: newValue ?? undefined,
                });
              }}
            />
          </Form.Item>
          <Form.Item name={['priceRange', 'max']} noStyle>
            <InputNumber
              size="small"
              min={value?.min ?? priceRange.min}
              placeholder="Max"
              prefix={symbol}
              className="w-24"
              value={value?.max}
              onChange={(newValue) => {
                onChange?.({
                  ...value,
                  max: newValue ?? undefined,
                });
              }}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};
